import React, { useState, useEffect } from "react";
import Title from "./title";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faPlus,
  faPrint,
  faX,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import PrintHead from "./PrintHead";
import PrintFooter from "./PrintFooter";
import API from "../api/axiosConfig";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import "./Tablestyle.css";

function TableComponent({
  extraTitleField,
  apiUrl,
  columns,
  titleIcon,
  title,
  transformRowFn,
  dropdownOptions,
  search,
  searchDate,
  searchTextProp,
  id,
  refreshDataProp,
  triggerReload,
  placeholderSearch,
}) {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [searchFrom, setSearchFrom] = useState(null);
  const [searchTo, setSearchTo] = useState(null);
  const [perPage, setPerPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [refreshData, setRefreshData] = useState(false);
  const navigate = useNavigate();
  const [totalAmount, setTotalAmount] = useState(0);

  const handleNavigate = (route, rowId) => {
    navigate(route.replace(":id", rowId));
  };

  // const formatNumber = (value) => {
  //   if (!isNaN(value) && value !== null && value !== "") {
  //     return Number(value).toLocaleString();
  //   }
  //   return value;
  // };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 1000);

    return () => clearTimeout(handler);
  }, [searchText]);

  const getNestedValue = (obj, path) => {
    return path
      .split(".")
      .reduce((acc, key) => (acc && acc[key] ? acc[key] : null), obj);
  };

  const fetchData = async () => {
    try {
      const response = await API.post(apiUrl, {
        perpage: perPage,
        page: page,
        search: debouncedSearchText,
        searchfrom: searchFrom ? dayjs(searchFrom).format("YYYY-MM-DD") : "",
        searchto: searchTo ? dayjs(searchTo).format("YYYY-MM-DD") : "",
        id: id ?? "",
        refreshData: refreshData,
      });

      if (!response || !response.data) {
        throw new Error("Failed to fetch data");
      }

      const json = response.data;
      //console.log(json);

      const records =
        Array.isArray(json) && Array.isArray(json[0]) ? json[0] : json;

      setData((prevData) => (page === 1 ? records : [...prevData, ...records]));
      // console.log(data);

      setTotalRecords(records.length);

      const sumAmount = records.reduce(
        (acc, record) => acc + (parseFloat(record.amount) || 0),
        0
      );
      setTotalAmount(sumAmount);

      //console.log(records);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [
    apiUrl,
    page,
    debouncedSearchText,
    searchFrom,
    searchTo,
    perPage,
    id,
    refreshData,
  ]);

  const totalPages = Math.ceil(totalRecords / perPage);

  const handlePageChange = (newPage) => {
    // if (newPage >= 1 && newPage <= totalPages) {
    setPage(newPage);
    // }
  };
  //console.log(totalRecords);

  const handlePrint = () => {
    window.print();
  };
  // console.log(data);

  useEffect(() => {
    if (triggerReload !== null) {
      setPage(1);
      setData([]);
      fetchData();
    }
  }, [triggerReload]);
   const handleExportExcel = () => {
    import("xlsx").then((xlsx) => {
      const ws = xlsx.utils.json_to_sheet(
        data.map((record, index) => {
          const row = {};
          row["#"] = index + 1;
          columns.forEach((col) => {
            if (col.key !== "actions") {
              row[col.name] = record[col.key];
            }
          });
          return row;
        })
      );
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Data");
      xlsx.writeFile(wb, `${title || "Export"}.xlsx`);
    });
  };

//  const handleExportPDF = async () => {
//   const { default: jsPDF } = await import("jspdf");
//   const { default: autoTable } = await import("jspdf-autotable");

//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: "a4",
//   });

//   doc.text(title || "Report", 14, 10);

//   const tableColumn = [
//     "#",
//     ...columns.filter((c) => c.key !== "actions").map((c) => c.name),
//   ];

//   const tableRows = data.map((record, i) => [
//     i + 1,
//     ...columns
//       .filter((c) => c.key !== "actions")
//       .map((c) => record[c.key]),
//   ]);

//   // ✅ الاستدعاء الصحيح في الإصدار الحديث:
//   autoTable(doc, {
//     head: [tableColumn],
//     body: tableRows,
//     startY: 20,
//     styles: { fontSize: 9 },
//   });

//   doc.save(`${title || "Report"}.pdf`);
// };


  return (
    <>
      <div className="printTabel-container">
        <div className="printCalc">
          {/* <Title title={title} icon={titleIcon} style={{ width: "unset" }} classname='rmtit' /> */}
          {/* <Title
            title={
              <>
                {extraTitleField && data.length > 0 && (
                  <>{getNestedValue(data[0], extraTitleField)} - </>
                )}
                {title}
              </>
            }
            icon={titleIcon}
            style={{ width: "unset" }}
            classname="rmtit"
          /> */}
          <Title
            title={
              <>
                {title}
                {extraTitleField && data.length > 0 && (
                  <>
                    {" "}
                    {title.length > 0 && " - "}
                    {extraTitleField !== "description"
                      ? getNestedValue(data[0], extraTitleField)
                      : getNestedValue(data[0], extraTitleField).match(
                          /from \[(.*?)\]/
                        )[1]}
                  </>
                )}
              </>
            }
            icon={titleIcon}
            style={{ width: "unset" }}
            classname="rmtit"
          />

          <div className="newContainer">
            <div className="actions-container newactions-container">
              {search !== false && (
                <>
                  <div className="search-container">
                    {searchTextProp !== false && (
                      <input
                        placeholder={
                          placeholderSearch ? placeholderSearch : "البحث"
                        }
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setPage(1);
                          setData([]);
                        }}
                        className="search-input styled-search-button "
                      />
                    )}

                    {searchText && (
                      <button
                        className="clear-button"
                        onClick={() => {
                          setSearchText("");
                          setPage(1);
                          setData([]);
                        }}
                        style={{
                          borderRadius: "20px",
                          backgroundColor: "var(--background-color)",
                        }}
                      >
                        <FontAwesomeIcon icon={faX} />
                      </button>
                    )}
                  </div>
                  {searchDate !== false && (
                    <>
                      <div className="date-container">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="من"
                            format="DD-MM-YYYY"
                            value={searchFrom}
                            onChange={(date) => {
                              setSearchFrom(date);
                              setPage(1);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                            className="cus-input"
                          />
                        </LocalizationProvider>
                        {searchFrom && (
                          <button
                            className="clear-button"
                            onClick={() => {
                              setSearchFrom(null);
                              setPage(1);
                            }}
                            style={{
                              borderRadius: "20px",
                              backgroundColor: "var(--background-color)",
                            }}
                          >
                            ❌
                          </button>
                        )}
                      </div>
                      <div className="date-container">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="إلى"
                            format="DD-MM-YYYY"
                            value={searchTo}
                            onChange={(date) => {
                              setSearchTo(date);
                              setPage(1);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                            className="cus-input"
                          />
                        </LocalizationProvider>
                        {searchTo && (
                          <button
                            className="clear-button"
                            onClick={() => {
                              setSearchTo(null);
                              setPage(1);
                            }}
                            style={{
                              borderRadius: "20px",
                              backgroundColor: "var(--background-color)",
                            }}
                          >
                            ❌
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}
              <div className="export-buttons">
              <button className="styled-download-button" onClick={handlePrint}>
                <FontAwesomeIcon icon={faPrint} />
              </button>

              <button
                className="styled-download-button"
                onClick={handleExportExcel}
                title="تصدير Excel"
              >
                <FontAwesomeIcon
                  icon={faFileExcel}
                  style={{ color: "green" }}
                />
              </button>
              </div>
              {/* <button
                className="styled-download-button"
                onClick={handleExportPDF}
                title="تصدير PDF"
              >
                <FontAwesomeIcon icon={faFilePdf} style={{ color: "red" }} />
              </button> */}

              </div>
              {refreshDataProp && refreshData === true ? fetchData() : ""}
            </div>

            {/* <div>
                    <select
                        className="search-input styled-search-button rowsdrop"
                        value={perPage}
                        onChange={(e) => {
                            setPerPage(Number(e.target.value));
                            setPage(1);
                        }}
                    >
                        <option value={10}>10 صفوف</option>
                        <option value={25}>25 صفوف</option>
                        <option value={50}>50 صفوف</option>
                        <option value={100}>100 صفوف</option>
                    </select>
                </div> */}
          </div>
          <div className="table-scroll">
            <table className="printTabel printContainer">
              <thead>
                <tr className="selected-row">
                  <td colSpan={columns.length + 1}>
                    <PrintHead />
                  </td>
                </tr>
                <tr className="printTabelHead selected-row">
                  <th>م</th>
                  {columns.map((column) => (
                    <th key={column.key}>{column.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((record, rowIndex) => {
                  const transformedRecord = transformRowFn
                    ? transformRowFn(record)
                    : record;
                  return (
                    <>
                      <tr key={rowIndex} className="selected-row">
                        <td>{rowIndex + 1}</td>
                        {columns.map((column) => (
                          <td key={column.key} data-label={column.name}>
                            {column.key === "actions" ? (
                              <Dropdown className="table-un-printable-ellipse">
                                <Dropdown.Toggle
                                  variant="secondary"
                                  size="sm"
                                  className="no-caret-dropdown rm-back"
                                >
                                  <FontAwesomeIcon icon={faEllipsisVertical} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {dropdownOptions
                                  .filter(
                                          (option) =>
                                            !option.visibleIf || option.visibleIf(record)
                                          )
                                  .map((option, idx) => (
                                    <Dropdown.Item
                                      key={idx}
                                      onClick={() => {
                                        if (option.action) {
                                          option.action(record.id, record);
                                        } else if (option.route) {
                                          handleNavigate(
                                            option.route,
                                            record.id
                                          );
                                        }
                                      }}
                                    >
                                      {option.label}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            ) : record[column.key] !== undefined ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html:
                                    column.key === "phone" ||
                                    column.key === "nationalid"
                                      ? transformedRecord[column.key]
                                      : transformedRecord[column.key],
                                }}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        ))}
                      </tr>
                    </>
                  );
                })}
              </tbody>
              <tfoot>
                <tr className="printTabelHead footerPrint selected-row">
                  <td colSpan={columns.length + 1}>
                    {" "}
                    {/* برضه +1 علشان المسلسل */}
                    <PrintFooter />
                  </td>
                </tr>
              </tfoot>
            </table>

            {columns.map((column, index) => (
              <p key={index} style={{ textAlign: "end" }}>
                {column.key === "amount" ? (
                  <strong>
                    الإجمالي : {totalAmount.toLocaleString()} ريال سعودي
                  </strong>
                ) : null}
              </p>
            ))}
          </div>
        </div>
        {totalRecords.length !== 0 && (
          <div className="tablepagination-container">
            <button
              className="page-button btn btn-secondary mt-3"
              onClick={() => handlePageChange(page + 1)}
              // disabled={page >= totalPages}
            >
              <FontAwesomeIcon icon={faPlus} /> تحميل المزيد
            </button>

            {/* <span className="align-self-center">
                        صفحة {page} من {totalPages}
                    </span>
                    
                    <button
                        className="page-button"
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1}
                    >
                        السابق
                    </button> */}
          </div>
        )}
        {/* <PrintFooter /> */}
    </>
  );
}

export default TableComponent;
